module.exports = __webpack_public_path__ + "img/zfb_5.30e591fc.png";